import { useMemo } from 'react'

import { useSelectedSystem } from '@/pages/User/pages/Home/components/TreePanel/TreePanelContext'
import { useGetDeploymentPackagesQuery } from '@/rtkApi'

import { mapDeploymentPackage } from './mapDeploymentPackage'
import { DEPLOYMENT_PACKAGE_PAGE_SIZE } from './types'

export const useDeploymentPackages = () => {
	const { selectedSystemId } = useSelectedSystem()
	const systemId = selectedSystemId ? Number(selectedSystemId) : undefined
	const hasSystemId = systemId != null && !Number.isNaN(systemId)

	const { data, isError, isLoading } = useGetDeploymentPackagesQuery(
		{
			pageNumber: 1,
			pageSize: DEPLOYMENT_PACKAGE_PAGE_SIZE,
			systemId: systemId as number,
		},
		{ skip: !hasSystemId },
	)

	const packages = useMemo(
		() => (data?.content ?? []).filter((item) => item.id != null).map(mapDeploymentPackage),
		[data?.content],
	)

	return {
		hasSystemId,
		isError,
		isLoading: hasSystemId && isLoading,
		packages,
		systemId: hasSystemId ? systemId : undefined,
	}
}
